import Joi from 'joi';
export var responseSchema = Joi.object({
    menu: Joi.array().items(Joi.object({
        name: Joi.string().required(),
        icon: Joi.string(),
        staticURL: Joi.string(),
        url: Joi.string(),
        permission: Joi.string(),
        nextLevelItems: Joi.link('...'),
    })),
});
